module.exports = __webpack_public_path__ + "static/media/ic_profile_placeholder.44247218.png";